module.exports = __webpack_public_path__ + "assets/img/202112-4.665e99f9.png";